import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import goodsApi from '../../api/goods';
import { message } from 'antd';

// 分页查询商品
export const fetchGoodsList = createAsyncThunk(
  'goods/fetchList',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await goodsApi.pageGoods(params);
      return response.data;
    } catch (error) {
      message.error('获取商品列表失败');
      return rejectWithValue(error.response.data);
    }
  }
);

// 添加商品
export const addGoods = createAsyncThunk(
  'goods/add',
  async (goodsData, { dispatch, rejectWithValue }) => {
    try {
      const processedData = {
        uid: goodsData.uid || null,
        name: goodsData.name,
        categoryId: goodsData.categoryId,
        price: goodsData.price,
        originalPrice: goodsData.originalPrice || null,
        stock: goodsData.stock,
        salesVolume: goodsData.salesVolume || 0,
        description: goodsData.description || null,
        status: goodsData.status || 'ON_SHELF',
        auditStatus: goodsData.auditStatus || 'PENDING',
        auditTime: goodsData.auditTime || null,
        auditAdminId: goodsData.auditAdminId || null,
        auditReason: goodsData.auditReason || null,
        goodsImages: goodsData.goodsImages || []
      };

      const response = await goodsApi.addGoods(processedData);
      message.success('商品添加成功');
      dispatch(fetchGoodsList());
      return response.data;
    } catch (error) {
      message.error('商品添加失败');
      return rejectWithValue(error.response.data);
    }
  }
);

// 更新商品
export const updateGoods = createAsyncThunk(
  'goods/update',
  async (goodsData, { dispatch, rejectWithValue }) => {
    try {
      const processedData = {
        id: goodsData.id,
        uid: goodsData.uid || null,
        name: goodsData.name,
        categoryId: goodsData.categoryId,
        price: goodsData.price,
        originalPrice: goodsData.originalPrice || null,
        stock: goodsData.stock,
        salesVolume: goodsData.salesVolume || 0,
        description: goodsData.description || null,
        status: goodsData.status || 'ON_SHELF',
        auditStatus: goodsData.auditStatus || 'PENDING',
        auditTime: goodsData.auditTime || null,
        auditAdminId: goodsData.auditAdminId || null,
        auditReason: goodsData.auditReason || null,
        goodsImages: goodsData.goodsImages || []
      };

      const response = await goodsApi.updateGoods(processedData);
      message.success('商品更新成功');
      dispatch(fetchGoodsList());
      return response.data;
    } catch (error) {
      message.error('商品更新失败');
      return rejectWithValue(error.response.data);
    }
  }
);

// 删除商品
export const deleteGoods = createAsyncThunk(
  'goods/delete',
  async (goodsId, { rejectWithValue }) => {
    try {
      const response = await goodsApi.deleteGoods(goodsId);
      message.success('商品删除成功');
      return response.data;
    } catch (error) {
      const errorMsg = error.response?.data?.message || '商品删除失败';
      message.error(errorMsg);
      return rejectWithValue(error.response?.data || { message: errorMsg });
    }
  }
);

const goodsSlice = createSlice({
  name: 'goods',
  initialState: {
    goodsList: [],
    total: 0,
    page: 1,
    pageSize: 10,
    loading: false,
    error: null,
    currentGoods: null
  },
  reducers: {
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
    },
    setCurrentGoods: (state, action) => {
      state.currentGoods = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchGoodsList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchGoodsList.fulfilled, (state, action) => {
        state.loading = false;
        state.goodsList = action.payload.records;
        state.total = action.payload.total;
      })
      .addCase(fetchGoodsList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { setPage, setPageSize, setCurrentGoods } = goodsSlice.actions;
export default goodsSlice.reducer; 